import { UseForm } from '@abyss/web/hooks/useForm/v2/useFormV2.types';
import { NavigateFunction } from 'react-router-dom';

import { adobeLinkTrackEvent } from '../AdobeTagging/adobeLinkTrackEvent';
import { getTypeAheadCategory } from '../Utils/adobeTrackUtils/adobeTrackUtils';
import { handleSearchSelected } from './SearchBar/utils';

export const onSubmitForm = (
  data: any,
  form: UseForm<any>,
  navigate: NavigateFunction,
  specialityPreferenceTable: any,
  {
    chipStore,
    setTypeaheadSearchStore,
    setAnalyticsState,
    setPCPSearchState,
    setChipValue,
    setCoverageType,
    setDetailsStore,
  }
) => {
  const searchTerm = form.getValues('searchTerm');
  const analyticsLinkName = 'search button';
  const typeaheadLinkName = 'typeahead search';
  specialityPreferenceTable?.map((item) => ({
    rollupCode: item.rollupCode,
    specialityCode: item.specialityCode,
  }));
  // TODO: This handleSearchSelected is not being used, should be rechecked and removed.
  if (searchTerm?.length > 1) {
    handleSearchSelected(
      false,
      specialityPreferenceTable,
      false,
      {
        ...data,
        searchTerm,
        linkName: analyticsLinkName,
        typeaheadLinkName,
        searchMethod: 'typed',
      },
      {
        chipStore,
        setTypeaheadSearchStore,
        setAnalyticsState,
        setPCPSearchState,
        setChipValue,
        setCoverageType,
        setDetailsStore,
      },
      navigate
    );
  }

  let analyticsLocationName = 'search-input-option-list';
  let analyticsSearchBlock;
  if (data?.searchType) {
    analyticsLocationName += `:${getTypeAheadCategory(data?.resultType)}`;
    analyticsSearchBlock = {
      linkPosition: '1',
    };
  }
  adobeLinkTrackEvent({
    name: analyticsLinkName,
    location: analyticsLocationName,
    type: 'internal',
    destinationUrl: '',
    ...(analyticsSearchBlock && { searchBlock: analyticsSearchBlock }),
  });
};

export function shouldShowSmartChoiceIntro() {
  const hasDismissedPopover = sessionStorage.getItem('hasDismissedPopover');
  const smartChoicePopoverDismissed = sessionStorage.getItem(
    'smartChoicePopoverDismissed'
  );
  return hasDismissedPopover === 'n' && smartChoicePopoverDismissed !== 'true';
}

export function shouldShowCoachMark(
  enablePopup: boolean,
  recommendationPreferencesStatus: any
) {
  const hasDismissedPopover = sessionStorage.getItem('hasDismissedPopover');
  const hasDismissedCoachMarkWeb =
    recommendationPreferencesStatus?.hasDismissedCoachMarkWeb;
  if (enablePopup) {
    // If popover hasn't been dismissed (hasDismissedPopover === 'n'), don't show coachmark
    if (hasDismissedPopover === 'n') {
      return false;
    }
    // If popover has been dismissed (hasDismissedPopover === 'y'), coachmark becomes independent
    if (hasDismissedPopover === 'y') {
      return hasDismissedCoachMarkWeb !== 'y';
    }
  }
  return hasDismissedCoachMarkWeb !== 'y';
}

export const handleCloseProviderNotFoundAlert = (
  setShowProviderNotFoundAlert
) => {
  setShowProviderNotFoundAlert(false);
  // Remove the hash from URL
  const { pathname, search } = window.location;
  history.replaceState({}, document.title, `${pathname}${search}`);
};

export const shouldShowDemoHeader = (
  isStandalone,
  isDemoFlagEnabled,
  enableMapViewEnhancements,
  resultsPage
) =>
  isStandalone &&
  isDemoFlagEnabled &&
  !(enableMapViewEnhancements && resultsPage);
